import type { RailLayout } from "@/data/rail-branches";
import { MARKER_DIAMETER } from "../../marker/MarkerMetrics/metrics";
import type { MarkerCircleOffset } from "@/lib/timeline/scene/SceneMotion/motion";
import { acquireClosenessAt } from "./touch";

const SIDE_GAP_PX = 8;

/**
 * Someone going to a vehicle leaves their seat, stands beside it for the visit, and returns.
 * Their seat stays theirs, so nobody else moves.
 */
export function vehicleVisitOffset(
  characterId: string,
  playheadMs: number,
  rail: Pick<RailLayout, "visits">,
  seated: MarkerCircleOffset,
  seatOfVehicle: (vehicleId: string, startMs: number) => MarkerCircleOffset,
): MarkerCircleOffset {
  const visit = rail.visits?.find((item) => (
    item.characterId === characterId && item.startMs <= playheadMs && playheadMs < item.endMs
  ));
  if (visit === undefined) {
    return seated;
  }
  const vehicle = seatOfVehicle(visit.vehicleId, visit.startMs);
  const beside = { dx: vehicle.dx + MARKER_DIAMETER + SIDE_GAP_PX, dy: vehicle.dy };
  const close = acquireClosenessAt(visit.startMs, visit.endMs, playheadMs);
  return {
    dx: seated.dx + (beside.dx - seated.dx) * close,
    dy: seated.dy + (beside.dy - seated.dy) * close,
  };
}
